import { FC, useEffect, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../Auth/AuthProvider';
import LoadingPage from '../LoadingPage';
import { useTranslation } from 'react-i18next';
import { useOptionCommercial } from '../../utils/options';


const local = window?.config?.CREDENTIALS?.LOCAL_MODE;
const BE_URL = window?.config?.CREDENTIALS?.REACT_BE_APP_URL;
const isSaml = !!BE_URL && window.location.href.includes(BE_URL);
const baseUrl = local
  ? window?.config?.CREDENTIALS?.BACKEND_READER_URL
  : (isSaml ? BE_URL : window?.config?.CREDENTIALS?.REACT_APP_URL);
const basePathname = "/auth";

const HandleAuthCallback: FC = () => {
  const { handleAuthCallback,handleSamlAuthCallback, isAuthenticated } = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const {t} = useTranslation();
  const options =  useOptionCommercial();
  const didRun = useRef<null | string>(null);
  const processedCode = useRef<null | string>(null);

  useEffect(() => {
    const code = searchParams.get('code');
    const method = searchParams.get('method');
    if (code && processedCode.current !== code) {
      processedCode.current = code;
      window.location.replace(`${baseUrl}${basePathname}/callback?code=${encodeURIComponent(code)}`);
      return;
    }
    if (method==='saml') {
      handleSamlAuthCallback()
      .then(() => navigate(options[0]?.value))
      .catch(() => {
        navigate('/login-error');
      });
    return;
    }

  }, [searchParams, handleSamlAuthCallback, navigate, options]);

  useEffect(() => {
    const loginTicket = searchParams.get('loginTicket');
    if (!loginTicket) {
      if (!searchParams.get('code')) navigate('/');
      return;
    }

    if(didRun.current!== loginTicket) {
      didRun.current = loginTicket;
      handleAuthCallback(loginTicket).catch(() => {
      navigate('/login-error');
    });

    }

  }, [handleAuthCallback, navigate, searchParams]);
  
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/commercial');
    }
  }, [navigate, isAuthenticated]);
  return <LoadingPage message={t('common.msg_finaliser_conx')} />;
};

export default HandleAuthCallback;
